import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Login, AuthActionTypes, Logout, UserRequested, UserLoaded, AuthActions, UserProgressLoaded } from './../actions/auth.actions';


// Angular
import { Injectable } from '@angular/core';

// RxJS
import { filter, mergeMap, tap, withLatestFrom, map, catchError } from 'rxjs/operators';
import { Observable, of, defer } from 'rxjs';

// NGRX
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';

// Auth
// import { User } from './../../auth/models/user';
import { AppState } from 'src/app/_clusters/reducers';
import { LoginService } from 'src/app/_clusters/services/login.service';
import { SubjectService } from 'src/app/_clusters/services/subject.service';







@Injectable()
export class AuthEffects {

  @Effect({ dispatch: false })
  login = this.actions$.pipe(
    ofType<Login>(AuthActionTypes.Login),
    tap(action => {
      localStorage.setItem(environment.authTokenKey, action.payload.authToken);
      this.store.dispatch(new UserRequested());
    })
  );
  @Effect({ dispatch: false })
  logout = this.actions$.pipe(
    ofType<Logout>(AuthActionTypes.Logout),
    tap(action => {
      localStorage.removeItem(environment.authTokenKey);
      localStorage.removeItem('mf_token');
      localStorage.removeItem('otb_id');
      this.router.navigateByUrl('/')
    })
  );

  // @Effect({ dispatch: true })
  // loadUser$ = this.actions$
  //   .pipe(
  //     ofType<UserRequested>(AuthActionTypes.UserRequested),
  //     withLatestFrom(this.store.pipe(select(isUserLoaded))),
  //     // tslint:disable-next-line: variable-name
  //     filter(([action, _isUserLoaded]) => !_isUserLoaded),
  //     // tslint:disable-next-line: variable-name
  //     mergeMap(([action, _isUserLoaded]) => this.auth.getUserByToken()),
  //     // tslint:disable-next-line: variable-name
  //     tap(_user => {
  //       if (_user) {
  //         this.store.dispatch(new UserLoaded(_user));
  //       } else {
  //         this.store.dispatch(new Logout());
  //       }
  //     })
  //   );

  @Effect()
  loadUser$ = this.actions$
    .pipe(
      ofType<UserRequested>(AuthActionTypes.UserRequested),
      mergeMap(
        () => this.auth.getUserByToken()
          .pipe(
            map((res: any) => {
              return new UserLoaded(res);
            }),
            catchError(error => of(new Logout()))
          )
      ),
    );
  @Effect()
  loadSubtopicProgress$ = this.actions$
    .pipe(
      ofType<AuthActions>(AuthActionTypes.UserProgressRequested),
      mergeMap(
        (action: any) => this.subject.gettopicreport(action.payload.subject_id)
          .pipe(
            map((res: any) => {
              return new UserProgressLoaded(res.data);
            }),
          )
      ),

    );
  @Effect()
  init$: Observable<Action> = defer(() => {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let observableResult = of({ type: 'NO_ACTION' });
    if (userToken) {
      observableResult = of(new Login({ authToken: userToken }));
    }
    return observableResult;
  });

  private returnUrl: string;
  constructor(
    private actions$: Actions,
    private router: Router,
    private subject: SubjectService,
    private store: Store<AppState>,
    private auth: LoginService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.returnUrl = event.url;
      }
    });
  }

}
